import {TranslationFunction} from "../../../i18n/i18n";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";
import {DigitalActionAuthMockResult} from "./DigitalActionAuthMockResult";

export class DigitalActionAuthMockResultFormatter {
    static formatResult(code: DigitalActionAuthMockResult | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(code, "digitalActionAuthMockResult", t);
    }
}
